import React from 'react'
import CheckboxField from 'uiComponents/input/checkbox/checkboxField'

interface UserRoleSectionProps {
    isAdminGranted: boolean
    handleAdminClick: (granted: boolean) => void
}

export const UserRoleSection = ({ isAdminGranted, handleAdminClick }: UserRoleSectionProps) => {
    return (
        <div className="user-role">
            <CheckboxField
                name="partner_admin"
                label="This is an admin user"
                checked={isAdminGranted}
                onChange={(e) => handleAdminClick(e.target.checked)}
            />
            <span className="checkbox-explanation">
                All permissions will be granted, including the ability to manage other users.
            </span>
        </div>
    )
}
